import { useEffect, useRef, useState } from 'react';
import { getCompanySettings } from '../services/api';

const fallbackCards = [
  { icon: '⚙️', title: 'International Quality Standards', desc: 'ISO-certified processes ensuring every machine meets global performance benchmarks.' },
  { icon: '🏭', title: 'Complete In-House Manufacturing', desc: 'CNC machining, welding, assembly, and testing all under one fully equipped roof.' },
  { icon: '🛠️', title: 'Expert After-Sales Support', desc: 'Dedicated technicians for installation, commissioning, and ongoing maintenance nationwide.' },
  { icon: '⚡', title: 'Custom Solutions & Fast Delivery', desc: 'Flexible engineering and scheduling to meet your exact specs and timeline.' },
];

const fallbackCerts = ['ISO 9001:2015', 'SNI Certified', '15+ Years'];

const WhyUs = () => {
  const sectionRef = useRef(null);
  const [tag, setTag] = useState('Why PT CITRA HERITAGE INDONESIA');
  const [heading, setHeading] = useState('Trusted by Industry Leaders');
  const [description, setDescription] = useState('PT CITRA HERITAGE INDONESIA delivers world-class machinery with meticulous engineering, rapid turnaround, and unparalleled after-sales support — ensuring your production never stops.');
  const [certs, setCerts] = useState(fallbackCerts);
  const [cards, setCards] = useState(fallbackCards);

  useEffect(() => {
    getCompanySettings().then(data => {
      if (!data) return;
      if (data.whyus_tag) setTag(data.whyus_tag);
      if (data.whyus_heading) setHeading(data.whyus_heading);
      if (data.whyus_description) setDescription(data.whyus_description);
      if (data.whyus_certs) {
        try {
          const parsed = typeof data.whyus_certs === 'string' ? JSON.parse(data.whyus_certs) : data.whyus_certs;
          if (Array.isArray(parsed) && parsed.length > 0) setCerts(parsed);
        } catch {}
      }
      if (data.whyus_cards) {
        try {
          const parsed = typeof data.whyus_cards === 'string' ? JSON.parse(data.whyus_cards) : data.whyus_cards;
          if (Array.isArray(parsed) && parsed.length > 0) setCards(parsed);
        } catch {}
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if(e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    const els = sectionRef.current.querySelectorAll('.rv,.rl,.rr');
    els.forEach(el => observer.observe(el));
    return () => els.forEach(el => observer.unobserve(el));
  }, [cards]);

  // Parse heading: wrap words after first line break hint in <em>
  const renderHeading = (text) => {
    if (!text) return null;
    const words = text.split(' ');
    if (words.length >= 3) {
      return <>{words[0]} {words[1]}<br/><em>{words.slice(2).join(' ')}</em></>;
    } else if (words.length === 2) {
      return <>{words[0]}<br/><em>{words[1]}</em></>;
    }
    return <em>{text}</em>;
  };

  return (
    <section id="why" ref={sectionRef}>
      <div className="wrap">
        <div className="why-layout">
          <div className="why-left rv">
            <div className="slide-index" style={{color:'var(--yd)'}}><span></span> {tag}</div>
            <h2 className="heading">{renderHeading(heading)}</h2>
            <p className="why-desc">{description}</p>
            <div className="why-certs">
              {certs.map((cert, i) => (
                <div className="cert-badge" key={i}><span className="dot"></span>{cert}</div>
              ))}
            </div>
          </div>
          <div className="why-grid rv d2">
            {cards.map((card, i) => (
              <div className="why-card" key={i}>
                <span className="wc-num">{String(i + 1).padStart(2, '0')} ——</span>
                <span className="wc-icon">{card.icon}</span>
                <div className="wc-title">{card.title}</div>
                <p className="wc-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;